import { Injectable } from "@angular/core";

import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";


@Injectable({
    providedIn: "root"
})
export class PortAgentFormService {
    constructor(private http: CommonHttpModule) { }

    getMasterData(params: {}): Observable<any> {
        return this.http.post<any>(
            'getmaster-data',
            params
        ).pipe(
            map(response => response)
        );
    }


    getVesselDetailByIMONumber(body: any): Observable<any> {
        return this.http.post<any>(`vessel-info-by-imo`,
            body
        ).pipe(
            map(response => response)
        );
    }


    submitPortAgentFormData(data: any) {
        return this.http.post<any>(
            'pda_pa_form_submit',
            data
        ).pipe(
            map(response => response)
        );

    }


    returnToMeraki(data: any) {
        return this.http.post('return_to_pda', data).pipe(map(response => response))

    }
}
